communication = {
    // Funkcia, ktora prijma data z hornej obrazovky
    listenBottomScreen(key, data) {
        try {
            if (data) {
                data = $.parseJSON(data);
                switch (key) {
                    case "biometryAutentification":
                        modal.hideInfoModal();
                        if (data) {
                            // trackovanie ne/uspesneho prihlasenia pomocou biometrie do GA
                            if (!["continuing"].includes(data.state)) { // tento stav nepotrebujem trackovat
                                try {
                                    var ga_attr_value = `state:${data?.state};info:${data?.infoGA};matchScore:${(data?.matchScore * 1).toFixed(2)};spoofCheckScore:${(data?.spoofCheckScore * 1).toFixed(2)}`;
                                    gtag('event', 'biometry_login', {'biometry_login_result': ga_attr_value});
                                    if (data?.state == "success") stored.loginMethod = 'biometria';
                                } catch (error) {
                                    console.error(error);
                                }
                            }
                            switch(data.state) {
                                case "unregisteredPlayer":
                                //     // zmena "unregisteredPlayer" ma rovnake spravanie ako "failed": SBWEB-294
                                //     // Skryje okno s prihlasenim, 'vypne' kameru
                                //     player.hideBiometryLogin(true);
                                //     // Zobrazi okno o moznostiach registracie
                                //     modal.openVLCModal("PLAYER_UNREGISTERED_BIOMETRY", false);
                                //     hideInfoModal();
                                // break;
                                case "failed":
                                /*
                                    Ak sa prihlasenie podari tesne pred vyprsanim timeout,
                                    horna obrazovka, este predtym ako dostane "success" od nativky,
                                    este stihne zaslat "failed" na spodnu obrazovku.
                                    V pripade timeout na hornej obrazovke si v data.info posielam "timeout" a data.timeStamp.
                                    Ak sa to stane, porovnavam ci tento nasledny "failed" nastal pred "success" z nativky.
                                    Ak ano a vysledok porovnania je < 0, cize v minulosti, tak ho ignorujem a neukazujem okno s chybou.
                                */
                                if (data.timeStamp && ((data.timeStamp - stored.BiometryLoginLastSuccess) < 0)) {
                                    profile.consoleLog && console.warn("Ignoring 'failed' biometry login due to timeout immediately after success login.");
                                    break;
                                };
                                player.hideBiometryLogin(false);
                                if (profile.IsBiometricLoginOnly) {
                                    // Jedina moznost prihlasenia je pomocou biometrie
                                    modal.openVLCModal('PLAYER_UNREGISTERED_BIOMETRIC_LOGIN_ONLY');
                                } else {
                                    // Viacere moznosti prihlasenia
                                    modal.showInfoModal(6, sets.loginModalTime, false, texts.BiometryLoginModalFailed, false, false, texts.BiometryLoginFailedUnregisteredLabel, {
                                        buttonCloseText: texts.BiometryLoginFailedCloseButton,
                                        buttonCloseAction: "player.anotherLoginOptions();",
                                        button2Text: texts.BiometryLoginFailedRepeatButton,
                                        button2Action: "player.biometryAgain(true);",
                                        button2CloseAction: "modal.hideInfoModal(); player.hideBiometryLogin(true, true);",
                                        buttonAdditionalText: texts.BiometryLoginFailedRegisterButton,
                                        buttonAdditionalAction: "modal.hideInfoModal(); modal.openVLCModal('PLAYER_UNREGISTERED_BIOMETRY');"
                                    });
                                }

                                break;
                                case "manyPlayers":
                                    // Pri biometryLogin detegovalo viac ako jednu tvar, ocakava sa zavolanie biometryAgain(true) z nativeApp po akcii playera
                                    // Skryje okno s prihlasenim
                                    player.hideBiometryLogin(false);
                                    // Skryje okno s informaciou o pokynoch k biometrickemu prihlaseniu
                                    modal.hideInfoModal();
                                break;
                                case "gamblingProhibitedPlayer":
                                    // Skryje okno s prihlasenim, 'vypne' kameru
                                    player.hideBiometryLogin(true);
                                    // Zobrazi okno o vyluceni
                                    modal.openVLCModal("PLAYER_GAMBLING_PROHIBITED");
                                    modal.hideInfoModal();
                                break;
                                case "success":
                                    // Nastavujem timestamp pre porovnanie s case "failed" (v tomto bloku vyssie) z dovodu "timeout" z hornej obrazovky po "success" z nativky
                                    stored.BiometryLoginLastSuccess = Date.now();
                                case "canceled":
                                    // Skryje okno s prihlasenim, 'vypne' kameru
                                    player.hideBiometryLogin(true);
                                    // Skryje okno s informaciou o pokynoch k biometrickemu prihlaseniu
                                    modal.hideInfoModal();
                                break;
                                case "restarting":
                                    // horna obrazovka sa bude restartovat pretoze doslo k chybe kamery a na dolnej zobrazujem info modal
                                    modal.showInfoModal(6, sets.loginModalTime, false, texts?.BiometryLoginFailedCameraModalTitle, texts?.BiometryLoginFailedCameraModalSubtitle, false, "&nbsp;", {});
                                    // Enabluje button Zobrazit udaje. Kym je zobrazeny info modal je button neklikatelny
                                    $(".user-data-pin__button").removeClass("ui-disabled");
                                break;
                                case "continuing":
                                default:
                                    if (data?.credentials === "privateAccess") {
                                        modal.showInfoModal("privateAccess", sets.loginModalTime, false, texts.PrivateAccessModalHeader, texts.PrivateAccessModalSubHeader, false, false, {buttonCloseText: texts.PrivateAccessCancel, buttonCloseAction: "modal.hideInfoModalPrivateAccess(true);"});
                                    } else {
                                        modal.showInfoModal(7, sets.loginModalTime, false, texts.BiometryLoginModalHeader, texts.BiometryLoginModalSubHeader, false, false, {});
                                    }
                                break;
                            }
                        }
                        break;
                    case "firstVirtualLiveFeedReference":
                        // Vrchna obrazovka vola spodnu s LiveFeedReference (aktualne prehravane video)
                        if (data && data.eventID) {
                            if (offer.vgL.oneVideo.includes(offer.leagueCupID)) {
                                $("#section .virtual-event").find(".ui-block-9 a").removeClass("virtual-game-play hide-element");
                                var playingVtiVirtualEvent = $("#section [livefeed-reference=" + data.eventID + "]");
                                $(playingVtiVirtualEvent).find(".ui-block-9 a").addClass('virtual-game-play virtual-game-playing')
                                $(playingVtiVirtualEvent).find(".ui-block-2 .icons-wrapper").text('').append('<span class="icon-kiron-stream"></span>');
                            } else if (offer.vti.actualFeedReference !== data.eventID) {
                                // Zmenila sa skupina zapasov v iframe, ako 1. je zobrazeny iny zapas
                                offer.vti.actualFeedReference = data.eventID;
                                service.loadPure('sportsBookEvents');
                            }
                        }
                        break;
                    case "biometryAutentificationPrivateAccess":
                        // Zatvára info modal priebehu skenovania tvare a povoli button pre overovanie playerID pomocou biometrie
                        $(".user-data-pin__button").removeClass("ui-disabled");
                        modal.hideInfoModal(false);
                        if (data.state === "success" && stored.PlayerID === data.requestorPlayerID) {
                            // Zobrazi cislo karty a pin uzivatela
                            userData().show();
                        } else {
                            // Mozne prichadzajuce data.state === "failed" || "canceled"
                            // Pripadne aktualne prihlaseny hrac nie je totozny s hracom ktory poziadal o zobrazenie udajov
                            modal.showInfoModal(6, sets.loginModalTime, false, texts.PrivateAccessFailed, false, false, false, {
                                button2Text: texts.BiometryLoginFailedRepeatButton,
                                button2Action: "userData().trigger();",
                                button2CloseAction: "modal.hideInfoModal(); player.hideBiometryLogin(true, true);",
                            });
                        }
                        break;
                    case "hideBiometryLogin":
                        // Vrchna obrazovka vola spodnu, sluzi na zatvorenie overovania pomocou biometrie
                        player.hideBiometryLogin();
                        break;
                    case "matchTrackerControllable":
                        communication.matchtrackerModule.panelRender(data);
                        break;
                    case "vlc":
                        // NativeApp vola spodnu webApp s qr kodom na odblokovanie SB
                        if (data && data.qrCode) {
                            stored.qrCode = data.qrCode;
                        } else {
                            delete stored.qrCode;
                        }
                        main.generateUnlockingQRcode();
                        break;
                    case "biometryOnboarding":
                        if (data) {
                            switch(data.state) {
                                case "canceled":
                                    console.trace("biometryOnboarding " + JSON.stringify(data));
                                    player.onboarding.stop();
                                    if (data.info === "timeout") {
                                        main.watcherAction(list.Count == 0 && !stored.PlayerID);
                                        // Skryje okno o odstraneni neaktivneho oddu t tiketu (dochadza k tomu napr. pri live tikete))
                                        modal.hideErr(true);
                                    }
                                    break
                                case "init":
                                    // Hrac dokoncil jednorazove odomknutie (biometry onboarding) v poslednom kroku zvolil moznost plnej registracie
                                    // vtedy nativeApp zavola listenTopScreen('biometryOnboarding','{"state":"canceled"}') -> preposlanie na webApp pre ukoncenie jednorazoveho odomknutia
                                    // nasledne nativeApp zavola listenTopScreen('biometryOnboarding','{"state":"init"}') -> preposlanie na webApp pre nstavenie flagu player.onboarding.inProgress
                                    // aby nenastal bug SBWEB-496
                                    player.onboarding.init();
                                    break
                                default:
                                    return false;
                            }
                        }
                    break;
                    case "biometryOnboardingTrack":
                        // trackovanie krokov a stavu jednorazoveho odomknutia a onboardingu do GA4
                        if (data) {
                            communication.onboardingTrackModule.onboardingFlow(data);
                        };
                    break;
                    case "test":
                        // Testovaci key - vrchna app zavolala synchronne spodnu, spodna odpoveda:
                        return 'If you can read this message on top screen, synchronous command from top app was successful';
                        break;
                    case "devContextMenuCommand":
                        // Prikazy z dev menu na hornej obrazovke, ktore sa maju vykonat v spodnej obrazovke
                        // varianta pre nativnu app, kde sa data posielaju cez listenTopScreen nie postMessage ako v pripade browsera v dev.js
                        console.warn("⬇️⬇️⬇️", data);
                        dev.executeMessageFromTopscreen(data);
                        break;
                    default:
                        return false;
                }
                return true;
            } else {
                return false;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Kontrola uzivatelskej aktivity na SB volana z nativky, aby webapp vedela, ze user interaguje s UI prvkami nativky, nie webovky
    nativeAppUserActivity(message) {
        profile?.ConsoleLog$?.nativeApp && console.info("nativeAppUserActivity: " + message);
        main.userAction();
    },

    // Funkcia, ktora posiela data na hornu obrazovku
    topScreen(key, data, backCall) {
        setTimeout(function () {
            try {
                if (key) {
                    // GA4 - trackovanie konca sledovania videa matchtracker/virtualky/quickbet
                    communication.dataTrackModule.track.video_end(key, data);
                    // Debug log o tom co sa posiela na hornu obrazovku
                    if (profile.ConsoleLog || profile.ConsoleLog$.TopScreen) {
                        var log = "[][][] TopScreen - " + key
                        if (backCall) log += " | backCall: " + backCall;
                        console.log(log);
                        console.log(data);
                    }

                    // Volanie na hornu obraozvku
                    if (data) {
                        data.initiator = "webApp";
                        data = JSON.stringify(data);
                        // main.createLog(3,
                        // "WebApp_Calling_ScreenApp_STACK",
                        //     [
                        //         `key: ${key}`,
                        //         `data: ${data}`,
                        //         `stack: ${new Error().stack}`
                        //     ].join("\n")
                        // );
                    }
                    if (!backCall) {
                        if (!data) {
                            CallTopScreen(key);
                        } else {
                            CallTopScreen(key, data);
                        }
                    } else {
                        // Aktualne nie su ziadne backCall funkcie (len testovacia)
                        backCall = CallTopScreen(key, data);

                        clearTimeout(timeoutTopScreenCall);
                        delete timeoutTopScreenCall;

                        if (ct.callTopScreen <= 3) {

                            if (backCall === "NoReturnValue") {
                                var timeoutTopScreenCall;
                                ct.callTopScreen++;

                                // Native app vykonava inu javascript funkciu
                                main.createLog(2, "CallTopScreen_NoReturnValue", "key: " + key + ", data: " + data);
                
                                timeoutTopScreenCall = setTimeout(function() {
                                    // opakovanie volania
                                    communication.topScreen(key, data, true);
                                }.bind(this), 100);
                            } else {
                                switch (key) {
                                    case "test":
                                        // testovacia odpoved pri volani spodna app => vrchna, odpoved vrchnej aplikacie: backCall.
                                        console.log("test: " + backCall);
                                        break;
                                    default:
                                        return false;
                                }
                                ct.callTopScreen = 1;
                            }
                        } else {
                            // nepodarilo sa odososlat spravu na vrchnu aplikaciu (po viacerych pokusoch)
                            ct.callTopScreen = 1;
                        }
                    }
                    return true;
                } else {
                    return false;
                }
            } catch (e) {
                main.createLog(
                3,
                "ScreenApp_Calling_WebApp_STACK_ERROR3",
                [
                    `key: ${key}`,
                    `data: ${data}`,
                    `err: ${String(e)}`
                ].join("\n")
                );
                return false;
            }
        }, 0);
    },

    // Funkcia na zatvorenie hornej obrazovky
    topScreenClose() {
        try {
            if (!stream.isStreamPlaying) {
                communication.topScreen(stored.topScreenActive, {screenShow: false});
                stored.topScreenActive = false;
                $("#events .virtual-event .virtual-game-playing").removeClass("virtual-game-playing");
                return true;
            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            return false;
        }
    },

    // Prepojenie na hornu obrazovku
    async statsTable(screenShow, screenFor) {
        try {
            if (offer.page != "virtualGames") {
                if (!screenShow) {
                    // Zatvorenie tabulky
                    if (!ct.topScreenClose) {
                        // Zavolanie nativnej app s parametrom false
                        ct.topScreenClose = setTimeout(function () {
                            communication.topScreenClose();
                        }.bind(this), sets.topScreenDelay);
                    }

                } else if (offer) {
                    // Otvorenie tabulky, pomocou volania nativnej app s potrebnymi parametrami
                    stored.topScreenActive = "statsTable";
                    clearTimeout(ct.topScreenClose);
                    ct.topScreenClose = false;

                    // Nacitanie IDs
                    var sID = rID = lID = brsID = eStreamID = eID = provider = null;

                    if (offer.SeSpID) {
                        sID = offer.SeSpID;
                    } else if (offer.eventID) {
                        // Ziska sportID. Nieje vybrany sport nieje offer.SeSpID (rozkliknute napr. live)
                        // alebo som na zozname na domovskej obrazovke
                        sID = $("#M" + offer.eventID + " .league-title").attr("sport-id")?.split("SP")[1] || $("#" + offer.eventID).attr("sport-id");
                    }
                    if (sID) {
                        if (offer.eventID) {
                            if (!screenFor) screenFor = "event";
                            // Video Stream (iba pre prebiehajuce LIVE zapasy)
                            if ((eStreamID = $("#event #eventInfo").attr("stream-id"))
                                && (provider = $("#event #eventInfo").attr("provider"))
                                && ($("#event #eventInfo").hasClass("is-live"))) {
                                stored.topScreenActive = "stream";
                                eID = offer.eventID;
                                var streamData = await stream.getStreamData();
                                stream.streamStart();

                            }
                            // MatchTracker (iba pre prebiehajuce LIVE zapasy)
                            else if (profile.MatchTracker
                                && (eID = $("#event #eventInfo").attr("livefeed-reference"))
                                && ($("#event #eventInfo").hasClass("is-live"))) {
                                 stored.topScreenActive = "matchTracker";
                            } else if ($("[id*=" + offer.eventID + "] .ui-block-1").find("span[class*='event-analysis']")[0]) {
                                // Analyzi
                                eID = offer.eventID;
                            }
                        }

                        if (offer.regionID != -1) {

                            rID = offer.regionID;
                            if (offer.leagueCupID != -1) {

                                lID = offer.leagueCupID
                                if (!screenFor) {
                                    screenFor = "league";
                                    // Prida betRadar SeasonID (len pre ligu)
                                    brsID = parseInt($("#" + offer.pointer).find('.stats-table-ico').attr('seasonID'));
                                    if (isNaN(brsID)) brsID = null;
                                }

                            } else {
                                if (!screenFor) screenFor = "region";
                            }

                        } else {
                            if (!screenFor) screenFor = "sport";
                        }
                    }

                    // Zavola na hornu obrazovku
                    communication.topScreen(stored.topScreenActive, {
                        screenShow: true,
                        screenFor: screenFor,
                        sportID: sID,
                        regionID: rID,
                        leagueID: lID,
                        seasonID: brsID,
                        eStreamID: eStreamID,
                        provider: provider,
                        eventID: eID,
                        streamData: streamData
                    });

                } else {
                    // Neda sa urcite ID pre ktore ma byt tabulka zobrazena
                    return false;
                }

            }
        } catch (e) {
            console.error("ERROR catched in function: " + main.catchFunctionCall(arguments));
            ct.topScreenClose = false;
            return false;
        }
    }
};

// Funkcie ktore maju byt dostupne z console:
startApp = function(step) {
    main.startApp(step);
};

// Funkcie ktore vyuziva nativeApp
setInitializeWebApp = function(data) {
    main.setInitializeWebApp(data);
};

setBalanceWithPlayerInfo = function(...args) {
    player.setBalanceWithPlayerInfo(...args);
};

setWarningInfo = function(...args) {
    home.setWarningInfo(...args);
};

setTile = function(...args) {
    home.setTile(...args);
};

showErr = function(...args) {
    modal.showErr(...args);
};

hideErr = function(...args) {
    modal.hideErr(...args);
};

ticketRepeat = function(...args) {
    ticketDetail.ticketRepeat(...args);
};

ticketReset = function(...args) {
    ticket.ticketReset(...args);
};

languageLabels = function(...args) {
    main.languageLabels(...args);
};

lockApp = function(...args) {
    main.lockApp(...args);
};

unlockApp = function(...args) {
    main.unlockApp(...args);
};

myTicketsFilter = function(...args) {
    player.playerTickets.myTicketsFilter(...args);
};

nativeAppUserActivity = function(...args) {
    communication.nativeAppUserActivity(...args);
};

// TODO: cammelCase
PromoCodeManualInsert = function(...args) {
    player.playerBonusModule.PromoCodeManualInsert(...args);
};

openVLCModal = function(...args) {
    modal.openVLCModal(...args);
};

openFreebetModal = function(...args) {
    modal.openFreebetModal(...args);
};

barCodeTicketInput = function(...args) {
    ticketDetail.barCodeTicketInput(...args);
};

openBonusModal = function(...args) {
    modal.openBonusModal(...args);
};

ShowDialogActivateCard = function(...args) {
    modal.showDialogActivateCard(...args);
};

biometryAgain = function(...args) {
    player.biometryAgain(...args);
};

biometryLogin = function(...args) {
    player.biometryLogin(...args);
};

listenBottomScreen = function(...args) {
    communication.listenBottomScreen(...args);
};

legalDocs = {
    show: function(...args) {
        more.menu.legalDocs.show(...args);
    },
    hidden: function(...args) {
        more.menu.legalDocs.hidden(...args);
    }
};

showDocument = function(...args) {
    more.menu.showDocument(...args);
};

isTicketInProgress = function(...args) {
    return ticket.isTicketInProgress(...args);
};

closingTime = function(...args) {
    modal.closingTime(...args);
};

setWinCurrencyClientBalance = function(...args) {
    player.setWinCurrencyClientBalance(args[0], isFromNative = true);
};

openIncomeSources = function() {
    player.incomeSourcesModule.showIncomeSourcesModal(false, true);
};
